import { downloadImageUseCase } from '@src/main/shared/application/download-file.usecase';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { createFileHttpRepository } from '@src/main/shared/infrastructure/FileHttpRepository';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useDownloadImage = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);

  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createFileHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async ({ keyFile, fileName }: { keyFile: string; fileName: string }) => {
      if (!repository) {
        throw new Error('Repository not initialized');
      }

      await downloadImageUseCase(keyFile, fileName, repository);
    },
  });
};
